import * as React from "react";
import { Link } from "@/components/common/Link";
const partners = [{
  id: 1,
  name: "Søndergaard Farm",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602682/img/partner_heritage_oak.png",
  url: "https://example.com/sondergaard"
}, {
  id: 2,
  name: "Østerfjord Catch",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602682/img/partner_coastal_catch.png",
  url: "https://example.com/osterfjord"
}, {
  id: 3,
  name: "Bornholm Orchards",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602682/img/partner_valley_vineyards.png",
  url: "https://example.com/bornholm"
}, {
  id: 4,
  name: "Nordic Grain Mill",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602682/img/partner_artisan_hearth.png",
  url: "https://example.com/nordic-grain"
}];
export default function OurLocalPartners() {
  return <section data-section-id="130740" id="our-producers" className="dark bg-background text-foreground py-24 sm:py-32 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-secondary)_0%,transparent_100%)] opacity-10 pointer-events-none" />

      <div className="mx-auto max-w-7xl px-6 lg:px-8 relative z-10">
        <div className="mx-auto max-w-2xl text-center mb-16 lg:mb-24">
          <h2 className="font-serif text-4xl tracking-tight sm:text-5xl lg:text-7xl text-foreground">
            The Hands Behind the Harvest
          </h2>
          <p className="mt-6 text-lg leading-8 text-muted-foreground font-sans max-w-xl mx-auto tracking-wide">
            Our kitchen is an extension of the Danish landscape. We collaborate with independent foragers and farmers who respect the slow, intentional rhythm of the Nordic seasons.
          </p>
        </div>

        <div className="mx-auto grid max-w-lg grid-cols-2 items-center gap-x-8 gap-y-12 sm:max-w-xl sm:grid-cols-2 sm:gap-x-10 sm:gap-y-14 lg:mx-0 lg:max-w-none lg:grid-cols-4">
          {partners.map((partner, i) => <div key={partner.id} data-index={i} className="flex justify-center items-center p-4">
              <Link to={partner.url} newTab className="group block relative w-full max-w-[160px] aspect-[3/1]">
                <img className="absolute inset-0 w-full h-full object-contain transition-all duration-700 ease-out grayscale opacity-40 brightness-150 contrast-75 group-hover:grayscale-0 group-hover:opacity-100 group-hover:brightness-100 group-hover:contrast-100 group-hover:scale-105" src={partner.logo} alt={`${partner.name} logo`} loading="lazy" />
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}